import { useLocation } from 'react-router-dom';
import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNotifications } from '../components/NotificationsPanel';
import useUnreadMessages from '../hooks/useUnreadMessages';
import { apiFetch } from '../config/api';
import Chat from '../components/Chat';
import FinancialReport from '../components/FinancialReport';
import NotificationsPanel from '../components/NotificationsPanel';
import Icon from '../components/Icon';
import { toast } from '../components/ToastProvider';
import '../styles/Dashboard.css';
import '../styles/AdminDashboard.css';
import '../styles/B2BTrainings.css';

const CATALOGUE = [
  { id:'p1',  name:'Szampon profesjonalny HAIRKUS',   unit:'szt', price:45,  category:'Pielęgnacja' },
  { id:'p2',  name:'Odżywka intensywna regenerująca', unit:'szt', price:55,  category:'Pielęgnacja' },
  { id:'p3',  name:'Maska do włosów Premium',         unit:'szt', price:75,  category:'Pielęgnacja' },
  { id:'p4',  name:'Wosk modelujący extra hold',      unit:'szt', price:38,  category:'Stylizacja'  },
  { id:'p5',  name:'Lakier do włosów mocny',          unit:'szt', price:29,  category:'Stylizacja'  },
  { id:'p6',  name:'Serum termoochronne',             unit:'szt', price:65,  category:'Stylizacja'  },
  { id:'p7',  name:'Farba do włosów (komplet 60ml)',  unit:'op',  price:22,  category:'Koloryzacja' },
  { id:'p8',  name:'Utleniacz 3% 1000ml',             unit:'szt', price:18,  category:'Koloryzacja' },
  { id:'p9',  name:'Utleniacz 6% 1000ml',             unit:'szt', price:18,  category:'Koloryzacja' },
  { id:'p10', name:'Rękawiczki jednorazowe (100szt)', unit:'op',  price:35,  category:'Akcesoria'   },
  { id:'p11', name:'Ręczniki fryzjerskie (10szt)',    unit:'op',  price:60,  category:'Akcesoria'   },
  { id:'p12', name:'Folia aluminiowa 100m',           unit:'rol', price:25,  category:'Akcesoria'   },
  { id:'p13', name:'Maszynka HairPro X3',             unit:'szt', price:320, category:'Sprzęt'      },
  { id:'p14', name:'Suszarka profesjonalna 2400W',    unit:'szt', price:480, category:'Sprzęt'      },
];

const AdminB2BPanel = () => {
  const [orders,       setOrders]      = useState([]);
  const [inventory,    setInventory]   = useState({});  
  const [filterStatus, setFilterStatus]= useState('pending');
  const [expandedOrder,setExpandedOrder]= useState(null);
  const [activeTab,    setActiveTab]   = useState('orders');
  const [selectedSalon, setSelectedSalon] = useState('');

  const load = async () => {
    try {
      const data = await apiFetch('/b2b/orders');
      setOrders(data || []);
    } catch {}
  };
 
  const loadInventory = async () => {
    try {
      const data = await apiFetch('/b2b/inventory');
      const grouped = {};
      data.forEach(item => {
        const salon = item.salon_name || 'Unknown';
        if (!grouped[salon]) grouped[salon] = {};
        const product = CATALOGUE.find(p => p.name === item.product_name);
        if (product) {
          grouped[salon][product.id] = item.stock;
        }
      });
      setInventory(grouped);
    } catch (err) {
      console.error('Load inventory error:', err);
    }
  };
 
  useEffect(() => { 
    load();
    loadInventory();
  }, []);

  const filtered = filterStatus === 'all'
    ? orders
    : orders.filter(o => o.status === filterStatus);

  const countByStatus = (s) => orders.filter(o => o.status === s).length;

  const approveOrder = async (orderId) => {
    try {
      await apiFetch(`/b2b/orders/${orderId}/status`, {
        method: 'PATCH',
        body: JSON.stringify({ status: 'approved' }),
      });
      load();
      toast.success('Zamówienie zaakceptowane - magazyn salonu zaktualizowany!');
    } catch { toast.error('Błąd podczas akceptacji'); }
  };

  const rejectOrder = async (orderId) => {
    try {
      await apiFetch(`/b2b/orders/${orderId}/status`, {
        method: 'PATCH',
        body: JSON.stringify({ status: 'rejected' }),
      });
      load();
      toast.info('Zamówienie odrzucone.');
    } catch { toast.error('Błąd podczas odrzucania'); }
  };

  const salonNames = Object.keys(inventory).sort();
  const totalInvValue = CATALOGUE.reduce((sum, p) =>
    sum + Object.values(inventory).reduce((s, inv) => s + (inv[p.id]||0)*p.price, 0), 0);

  const STATUS = {
    pending:  { bg:'#fef3c7', color:'#92400e', label:'Oczekuje',      icon:'clock'     },
    approved: { bg:'#d1fae5', color:'#065f46', label:'Zaakceptowane', icon:'confirmed' },
    rejected: { bg:'#fee2e2', color:'#991b1b', label:'Odrzucone',     icon:'rejected'  },
  };

  return (
    <div className="admin-b2b-wrapper">
      <div className="admin-panel-header">
        <div className="admin-panel-header-left">
          <div className="admin-panel-icon" style={{background:'linear-gradient(135deg,#1e3c72,#2a5298)'}}>
            <Icon name="package" color="white" size="xl" />
          </div>
          <div>
            <h2>Zarządzanie B2B</h2>
            <p>Zamówienia produktów od franczyzobiorców i salonów</p>
          </div>
        </div>
        <div className="admin-panel-stats">
          <div className="admin-panel-stat"><strong style={{color:'#f59e0b'}}>{countByStatus('pending')}</strong><span>Oczekujące</span></div>
          <div className="admin-panel-stat"><strong style={{color:'#10b981'}}>{countByStatus('approved')}</strong><span>Zatwierdzonych</span></div>
          <div className="admin-panel-stat"><strong style={{color:'#1e3c72'}}>{totalInvValue.toLocaleString('pl-PL')} zł</strong><span>Wartość magazynów</span></div>
        </div>
      </div>

      <div className="admin-sub-tabs">
        <button className={`admin-sub-tab ${activeTab==='orders'?'active':''}`} onClick={() => setActiveTab('orders')}>
          <Icon name="list" style={{marginRight:'7px'}} />Zamówienia
          {countByStatus('pending') > 0 && <span className="sub-tab-badge">{countByStatus('pending')}</span>}
        </button>
        <button className={`admin-sub-tab ${activeTab==='inventory'?'active':''}`} onClick={() => setActiveTab('inventory')}>
          <Icon name="package" style={{marginRight:'7px'}} />Stan magazynowy
        </button>
      </div>

      {activeTab === 'orders' && (
        <div>
          <div className="admin-filter-pills">
            {[['all','Wszystkie'],['pending','Oczekujące'],['approved','Zatwierdzone'],['rejected','Odrzucone']].map(([val,label]) => (
              <button key={val}
                className={`admin-filter-pill ${filterStatus===val?'active':''}`}
                onClick={() => setFilterStatus(val)}>
                {label}
                <span className="pill-count">{val==='all' ? orders.length : countByStatus(val)}</span>
              </button>
            ))}
          </div>

          {filtered.length === 0 ? (
            <div className="b2b-empty-state">
              <div className="b2b-empty-icon"><Icon name="package" color="#d1d5db" size="2x" /></div>
              <h3>Brak zamówień</h3>
              <p>Zamówienia B2B od salonów i franczyzobiorców pojawią się tutaj</p>
            </div>
          ) : (
            <div className="admin-orders-list">
              {[...filtered].reverse().map(order => {
                const sc = STATUS[order.status] || STATUS.pending;
                const isOpen = expandedOrder === order.id;
                return (
                  <div key={order.id} className={`admin-order-card ${order.status}`}>
                    <div className="admin-order-head" onClick={() => setExpandedOrder(isOpen ? null : order.id)}>
                      <div className="admin-order-meta">
                        <div className="admin-order-salon">
                          <Icon name="salon" color="#1e3c72" style={{marginRight:'8px'}} />
                          <strong>{order.salon_name}</strong>
                        </div>
                        <span className="admin-order-date">
                          <Icon name="calendar" style={{marginRight:'5px',color:'#9ca3af'}} />
                          {new Date(order.created_at || order.createdAt).toLocaleDateString('pl-PL', {day:'numeric',month:'long',year:'numeric'})}
                        </span>
                        <span className="admin-order-items-count">
                          {order.items.length} pozycji • {order.items.reduce((s,i)=>s+i.qty,0)} szt.
                        </span>
                      </div>
                      <div className="admin-order-right">
                        <strong className="admin-order-total">{order.total} zł</strong>
                        <span className="admin-status-pill" style={{background:sc.bg,color:sc.color}}>
                          <Icon name={sc.icon} style={{marginRight:'5px',fontSize:'0.85em'}} />{sc.label}
                        </span>
                        <Icon name={isOpen?'chevron-up':'chevron-down'} color="#9ca3af" />
                      </div>
                    </div>
                    {isOpen && (
                      <div className="admin-order-details">
                        <div className="admin-order-items-table">
                          <div className="admin-order-items-header">
                            <span>Produkt</span><span>Kategoria</span><span>Ilość</span><span>Cena jedn.</span><span>Łącznie</span>
                          </div>
                          {order.items.map((item,i) => (
                            <div key={i} className="admin-order-item-row">
                              <span><strong>{item.name}</strong></span>
                              <span style={{color:'#6b7280',fontSize:'0.88em'}}>{item.category}</span>
                              <span><strong>{item.qty} {item.unit}</strong></span>
                              <span>{item.price} zł</span>
                              <span><strong style={{color:'#1e3c72'}}>{item.subtotal} zł</strong></span>
                            </div>
                          ))}
                          <div className="admin-order-items-total">
                            <span>Łączna wartość zamówienia:</span>
                            <strong>{order.total} zł</strong>
                          </div>
                        </div>
                        {order.status === 'pending' && (
                          <div className="admin-order-actions">
                            <button className="action-btn accept-btn" onClick={() => approveOrder(order.id)}>
                              <Icon name="check" style={{marginRight:'7px'}} />Akceptuj i dodaj do magazynu
                            </button>
                            <button className="action-btn reject-btn" onClick={() => rejectOrder(order.id)}>
                              <Icon name="close" style={{marginRight:'7px'}} />Odrzuć zamówienie
                            </button>
                          </div>
                        )}
                        {order.status === 'approved' && (
                          <div className="admin-approved-info">
                            <Icon name="confirmed" color="#059669" style={{marginRight:'8px'}} />
                            Produkty zostały dodane do magazynu salonu {order.salon_name}
                            {order.approvedAt && ` - ${new Date(order.approved_at || order.approvedAt).toLocaleDateString('pl-PL')}`}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {activeTab === 'inventory' && (
        <div>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
            padding: '16px',
            background: 'white',
            borderRadius: '12px',
            border: '2px solid #e5e7eb'
          }}>
            <div>
              <h3 style={{margin: 0, color: '#1e3c72'}}>
                <Icon name="package" style={{marginRight: '8px'}} />
                Stan magazynowy
              </h3>
              <p style={{margin: '4px 0 0', color: '#6b7280', fontSize: '0.9em'}}>
               {selectedSalon || 'Wybierz salon aby wyświetlić magazyn'}
              </p>
            </div>
            
            {salonNames.length > 0 && (
              <select 
                value={selectedSalon}
                onChange={(e) => setSelectedSalon(e.target.value)}
                style={{
                  padding: '10px 16px',
                  fontSize: '15px',
                  border: '2px solid #e5e7eb',
                  borderRadius: '8px',
                  background: 'white',
                  cursor: 'pointer',
                  minWidth: '250px',
                  color: selectedSalon ? '#111' : '#9ca3af'
                }}
              >
                <option value="" disabled>Wybierz salon...</option>
                {salonNames.map(name => (
                  <option key={name} value={name}>{name}</option>
                ))}
              </select>
            )}
          </div>

          {!selectedSalon ? (
            null
          ) : salonNames.length === 0 ? (
            <div className="b2b-empty-state">
              <div className="b2b-empty-icon"><Icon name="package" color="#d1d5db" size="2x" /></div>
              <h3>Brak danych magazynowych</h3>
              <p>Magazyny zostaną uzupełnione po zaakceptowaniu zamówień B2B</p>
            </div>
          ) : (
            <div className="admin-inv-table-wrap">
              <table className="admin-inv-table">
                <thead>
                  <tr>
                    <th>Produkt</th>
                    <th style={{textAlign:'left'}}>Kategoria</th>
                    <th style={{textAlign:'center'}}>{selectedSalon}</th>
                    <th style={{textAlign:'right'}}>Wartość salonu</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const salonsToShow = [selectedSalon];
                    const productsInInventory = new Set();
                    salonsToShow.forEach(salonName => {
                      Object.keys(inventory[salonName] || {}).forEach(productId => {
                        const product = CATALOGUE.find(p => p.id === productId);
                        if (product) productsInInventory.add(product.id);
                      });
                    });
                    const productsToShow = CATALOGUE.filter(p => productsInInventory.has(p.id));
                    if (productsToShow.length === 0) {
                      return (
                        <tr>
                          <td colSpan="100" style={{textAlign:'center', padding:'40px', color:'#9ca3af'}}>
                            <div style={{display:'flex', flexDirection:'column', alignItems:'center', gap:'12px'}}>
                              <Icon name="package" color="#d1d5db" size="2x" />
                              <div>
                                <p style={{margin: '0', fontSize:'1.1em', fontWeight:600}}>Brak produktów w magazynie</p>
                                <p style={{margin: '8px 0 0', fontSize:'0.9em'}}>
                                  {`Salon "${selectedSalon}" nie ma produktów w magazynie`}
                                </p>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    }
                    return productsToShow.map(p => {
                      const total = salonsToShow.reduce((s,n) => s+(inventory[n]?.[p.id]||0), 0);
                      const networkVal = salonsToShow.reduce((s,n) => s+(inventory[n]?.[p.id]||0)*p.price, 0);
                      return (
                        <tr key={p.id} className={total === 0 ? 'inv-row-zero' : total < 5 ? 'inv-row-low' : ''}>
                          <td><strong style={{fontSize:'0.9em'}}>{p.name}</strong></td>
                          <td style={{textAlign:'center'}}><span style={{fontSize:'0.78em',color:'#6b7280'}}>{p.category}</span></td>
                          {salonsToShow.map(s => {
                            const qty = inventory[s]?.[p.id] || 0;
                            return (
                              <td key={s} style={{textAlign:'center'}}>
                                <span className={`stock-badge ${qty===0?'stock-zero':qty<3?'stock-low':'stock-ok'}`}>{qty}</span>
                              </td>
                            );
                          })}
                          <td style={{textAlign:'right',color:'#1e3c72',fontWeight:600}}>{networkVal.toLocaleString('pl-PL')} zł</td>
                        </tr>
                      );
                    });
                  })()}
                </tbody>
                <tfoot>
                  <tr style={{borderTop:'2px solid #1e3c72'}}>
                    <td colSpan="3" style={{textAlign:'right',fontWeight:700,padding:'16px',fontSize:'1.05em'}}>
                      Łączna wartość salonu:
                    </td>
                    <td style={{textAlign:'right',padding:'16px',color:'#1e3c72',fontWeight:700,fontSize:'1.15em'}}>
                      {(() => {
                        const salonsToShow = [selectedSalon];
                        const productsInInventory = new Set();
                        salonsToShow.forEach(salonName => {
                          Object.keys(inventory[salonName] || {}).forEach(productId => {
                            const product = CATALOGUE.find(p => p.id === productId);
                            if (product) productsInInventory.add(product.id);
                          });
                        });
                        const productsToShow = CATALOGUE.filter(p => productsInInventory.has(p.id));
                        return productsToShow.reduce((sum, p) => {
                          return sum + salonsToShow.reduce((s, n) => s + (inventory[n]?.[p.id]||0)*p.price, 0);
                        }, 0).toLocaleString('pl-PL');
                      })()}{' zł'}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const TRAINING_STATUS = {
  pending:   { bg:'#fef3c7', color:'#92400e', label:'Oczekuje',      icon:'clock'     },
  approved:  { bg:'#d1fae5', color:'#065f46', label:'Zatwierdzone', icon:'confirmed' },
  rejected:  { bg:'#fee2e2', color:'#991b1b', label:'Odrzucone',    icon:'rejected'  },
  completed: { bg:'#ede9fe', color:'#4c1d95', label:'Zrealizowane', icon:'check'     },
};

const AdminTrainingsPanel = () => {
  const [trainings,    setTrainings]   = useState([]);
  const [filterStatus, setFilterStatus]= useState('pending');
  const [expanded,     setExpanded]    = useState(null);

  const load = async () => {
    try {
      const data = await apiFetch('/b2b/trainings');
      setTrainings(data || []);
    } catch {}
  };
  useEffect(() => { load(); }, []);

  const filtered = filterStatus === 'all'
    ? trainings
    : trainings.filter(t => t.status === filterStatus);

  const countBy = (s) => trainings.filter(t => t.status === s).length;

  const updateStatus = async (id, status) => {
    try {
      await apiFetch(`/b2b/trainings/${id}/status`, {
        method: 'PATCH',
        body: JSON.stringify({ status }),
      });
      load();
      const msgs = { approved:'Wniosek zatwierdzony!', rejected:'Wniosek odrzucony.', completed:'Szkolenie oznaczone jako zrealizowane.' };
      toast.success(msgs[status] || 'Zaktualizowano.');
    } catch { toast.error('Błąd podczas aktualizacji'); }
  };

  return (
    <div className="admin-b2b-wrapper">
      <div className="admin-panel-header">
        <div className="admin-panel-header-left">
          <div className="admin-panel-icon" style={{background:'linear-gradient(135deg,#4f46e5,#7c3aed)'}}>
            <Icon name="staff" color="white" size="xl" />
          </div>
          <div>
            <h2>Wnioski Szkoleniowe</h2>
            <p>Zarządzaj szkoleniami dla pracowników salonów franczyzowych</p>
          </div>
        </div>
        <div className="admin-panel-stats">
          <div className="admin-panel-stat"><strong style={{color:'#f59e0b'}}>{countBy('pending')}</strong><span>Do rozpatrzenia</span></div>
          <div className="admin-panel-stat"><strong style={{color:'#10b981'}}>{countBy('approved')}</strong><span>Zatwierdzone</span></div>
          <div className="admin-panel-stat"><strong style={{color:'#6366f1'}}>{countBy('completed')}</strong><span>Zrealizowane</span></div>
        </div>
      </div>

      <div className="admin-filter-pills">
        {[['all','Wszystkie'],['pending','Oczekujące'],['approved','Zatwierdzone'],['rejected','Odrzucone'],['completed','Zrealizowane']].map(([val,label]) => (
          <button key={val}
            className={`admin-filter-pill ${filterStatus===val?'active':''}`}
            onClick={() => setFilterStatus(val)}>
            {label}
            <span className="pill-count">{val==='all' ? trainings.length : countBy(val)}</span>
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="b2b-empty-state">
          <div className="b2b-empty-icon"><Icon name="staff" color="#d1d5db" size="2x" /></div>
          <h3>Brak wniosków szkoleniowych</h3>
          <p>Wnioski od franczyzobiorców pojawią się tutaj</p>
        </div>
      ) : (
        <div className="admin-orders-list">
          {[...filtered].reverse().map(t => {
            const sc = TRAINING_STATUS[t.status] || TRAINING_STATUS.pending;
            const isOpen = expanded === t.id;
            return (
              <div key={t.id} className={`admin-order-card ${t.status}`}>
                <div className="admin-order-head" onClick={() => setExpanded(isOpen ? null : t.id)}>
                  <div className="admin-order-meta">
                    <div className="admin-order-salon">
                      <Icon name="franchisee" color="#4f46e5" style={{marginRight:'8px'}} />
                      <strong>{t.userName}</strong>
                      <span style={{color:'#9ca3af',fontSize:'0.85em',marginLeft:'8px'}}>{t.userEmail}</span>
                    </div>
                    <span className="admin-order-date">
                      <Icon name="service" style={{marginRight:'5px',color:'#9ca3af'}} />
                      <strong style={{color:'#374151'}}>{t.topicName}</strong>
                    </span>
                    <span style={{color:'#6b7280',fontSize:'0.85em'}}>
                      <Icon name="users" style={{marginRight:'4px'}} />{t.employeeCount} uczestników
                    </span>
                  </div>
                  <div className="admin-order-right">
                    {t.preferredDate && (
                      <span style={{color:'#6b7280',fontSize:'0.85em'}}>
                        <Icon name="calendar" style={{marginRight:'4px'}} />
                        {new Date(t.preferred_date || t.preferredDate).toLocaleDateString('pl-PL')}
                      </span>
                    )}
                    <span className="admin-status-pill" style={{background:sc.bg,color:sc.color}}>
                      <Icon name={sc.icon} style={{marginRight:'5px',fontSize:'0.85em'}} />{sc.label}
                    </span>
                    <Icon name={isOpen?'chevron-up':'chevron-down'} color="#9ca3af" />
                  </div>
                </div>

                {isOpen && (
                  <div className="admin-order-details">
                    <div className="trainings-detail-grid">
                      <div><label>Temat</label><p><strong>{t.topicName}</strong></p><p style={{color:'#9ca3af',fontSize:'0.85em'}}>{t.topicGroup}</p></div>
                      <div><label>Uczestnicy</label><p>{t.employeeNames}</p></div>
                      <div><label>Liczba osób</label><p>{t.employeeCount}</p></div>
                      <div><label>Format</label><p>{t.format}</p></div>
                      {t.preferredDate && <div><label>Preferowana data</label><p>{new Date(t.preferred_date || t.preferredDate).toLocaleDateString('pl-PL',{weekday:'long',day:'numeric',month:'long',year:'numeric'})}</p></div>}
                      {t.notes && <div style={{gridColumn:'1/-1'}}><label>Uwagi franczyzobiorcy</label><p>{t.notes}</p></div>}
                      <div><label>Złożono</label><p style={{color:'#9ca3af',fontSize:'0.85em'}}>{new Date(t.submitted_at || t.submittedAt).toLocaleString('pl-PL')}</p></div>
                    </div>
                    {t.status === 'pending' && (
                      <div className="admin-order-actions">
                        <button className="action-btn accept-btn" onClick={() => updateStatus(t.id,'approved')}>
                          <Icon name="check" style={{marginRight:'7px'}} />Zatwierdź szkolenie
                        </button>
                        <button className="action-btn reject-btn" onClick={() => updateStatus(t.id,'rejected')}>
                          <Icon name="close" style={{marginRight:'7px'}} />Odrzuć wniosek
                        </button>
                      </div>
                    )}
                    {t.status === 'approved' && (
                      <div className="admin-order-actions">
                        <button className="action-btn complete-btn" onClick={() => updateStatus(t.id,'completed')}>
                          <Icon name="check" style={{marginRight:'7px'}} />Oznacz jako zrealizowane
                        </button>
                        <div className="admin-approved-info">
                          <Icon name="confirmed" color="#059669" style={{marginRight:'8px'}} />
                          Wniosek zatwierdzony - skontaktuj się z franczyzobiorcą celem ustalenia terminu.
                        </div>
                      </div>
                    )}
                    {t.status === 'completed' && (
                      <div className="admin-approved-info" style={{background:'#ede9fe',color:'#4c1d95'}}>
                        <Icon name="check" color="#6366f1" style={{marginRight:'8px'}} />
                        Szkolenie zrealizowane {t.updatedAt ? new Date(t.updated_at || t.updatedAt).toLocaleDateString('pl-PL') : ''}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const ROLES = ['client','salon','admin','franchisee'];
const ROLE_LABELS = { client:'Klient', salon:'Salon', admin:'Administrator', franchisee:'Franczyzobiorca' };
const ROLE_ICONS = { client:'user', salon:'scissors', admin:'admin', franchisee:'franchisee' };

const EMPTY_USER = { firstName:'', lastName:'', email:'', password:'', phone:'', role:'client', salonName:'', salonCity:'', salonAddress:'' };

const AdminPushPanel = ({ user, users = [] }) => {
  const [pushTitle, setPushTitle] = useState('');
  const [pushText, setPushText]   = useState('');
  const [pushTarget, setPushTarget] = useState('all');
  const [pushSent, setPushSent]   = useState(false);
  const [pushSentCount, setPushSentCount] = useState(0);

  const sendBroadcast = async () => {
    if (!pushTitle.trim()) return;
    try {
      const { sent } = await apiFetch('/notifications/broadcast', {
        method: 'POST',
        body: JSON.stringify({ title: pushTitle, text: pushText, target: pushTarget }),
      });
      setPushSentCount(sent);
      setPushSent(true);
      setTimeout(() => { setPushSent(false); setPushTitle(''); setPushText(''); setPushSentCount(0); }, 4000);
    } catch {
      toast.error('Błąd podczas wysyłania powiadomień');
    }
  };

  return (
    <div className="dashboard-content-single" style={{maxWidth:'900px', margin:'0 auto'}}>
      <div className="admin-push-panel">
        <div className="admin-push-header">
          <Icon name="notification" size="lg" color="white" />
          <div>
            <h2>Powiadomienia push</h2>
            <p>Wyślij wiadomość do wybranych użytkowników sieci</p>
          </div>
        </div>
        <div className="admin-push-form">
          <div className="admin-push-target">
            <label>Odbiorcy:</label>
            <div className="admin-push-target-btns">
              {[['all','Wszyscy'],['salons','Salony'],['franchisees','Franczyzobiorcy'],['clients','Klienci'],['admins','Administratorzy']].map(([val,lbl]) => (
                <button key={val} className={`push-target-btn ${pushTarget===val?'active':''}`} onClick={() => setPushTarget(val)}>
                  {lbl}
                  <span className="push-target-count">
                    {val === 'all' ? users.length
                      : val === 'admins' ? users.filter(u => u.role === 'admin').length
                      : val === 'salons' ? users.filter(u => u.role === 'salon').length
                      : val === 'franchisees' ? users.filter(u => u.role === 'franchisee').length
                      : users.filter(u => u.role === 'client').length}
                  </span>
                </button>
              ))}
            </div>
          </div>
          <div className="admin-push-fields">
            <div className="spanel-field">
              <label>Tytuł powiadomienia <span style={{color:'#ef4444'}}>*</span></label>
              <input value={pushTitle} onChange={e => setPushTitle(e.target.value)} placeholder="np. Nowa promocja HAIRKUS!" maxLength={80} />
            </div>
            <div className="spanel-field">
              <label>Treść (opcjonalna)</label>
              <textarea value={pushText} onChange={e => setPushText(e.target.value)} placeholder="Szczegóły wiadomości..." rows={3} />
            </div>
          </div>
          <div className="admin-push-actions">
            <button className="admin-push-send-btn" onClick={sendBroadcast} disabled={!pushTitle.trim() || pushSent}>
              {pushSent
                ? <><Icon name="check" style={{marginRight:'8px'}} />Wysłano!</>
                : <><Icon name="send" style={{marginRight:'8px'}} />Wyślij powiadomienie</>}
            </button>
            {pushSent && <span className="push-sent-note"><Icon name="confirmed" color="#059669" style={{marginRight:'6px'}} />Wysłano do {pushSentCount} użytkownik{pushSentCount === 1 ? 'a' : 'ów'}!</span>}
          </div>
        </div>
      </div>
      <div className="dashboard-card-full">
        <NotificationsPanel user={user} />
      </div>
    </div>
  );
};

const AdminDashboard = () => {
  const { user } = useAuth();
  const { unread: notifUnread } = useNotifications(user?.id);
  const { unreadCount: chatUnread, unreadBreakdown } = useUnreadMessages(user);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('overview');
  const [bookings,     setBookings]     = useState([]);
  const [users,        setUsers]        = useState([]);
  const [reviews,      setReviews]      = useState([]);
  const [applications, setApplications] = useState([]);
  const [salonsList,   setSalonsList]   = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [salonSearch, setSalonSearch] = useState('');
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [deleteUserConfirm, setDeleteUserConfirm] = useState(null);
  const [editUser, setEditUser] = useState(null);
  const [savingEditUser, setSavingEditUser] = useState(false);
  const [approveAppModal, setApproveAppModal] = useState(null);
  const [approveAppForm, setApproveAppForm] = useState({ email: '', password: '' });
  const [approvingApp, setApprovingApp] = useState(false);

  useEffect(() => {
    const handleChatDeleted = () => setSelectedChat(null);
    window.addEventListener('chat-deleted', handleChatDeleted);
    return () => window.removeEventListener('chat-deleted', handleChatDeleted);
  }, []);

  const [filterSalon,  setFilterSalon]  = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterDate,   setFilterDate]   = useState('');
  const [sortBy,       setSortBy]       = useState('date_desc');
  const [searchClient, setSearchClient] = useState('');
  const [filterReviewSalon, setFilterReviewSalon] = useState('');
  const [filterRating,      setFilterRating]      = useState('');
  const [filterRole, setFilterRole] = useState('');
  const [searchUser, setSearchUser] = useState('');
  const [showAddUser, setShowAddUser] = useState(false);
  const [newUser, setNewUser] = useState(EMPTY_USER);
  const [savingUser, setSavingUser] = useState(false);
  const [selectedSalonDetail, setSelectedSalonDetail] = useState(null);

  const [salonMode, setSalonMode] = useState('existing'); // 'existing' | 'new'
  const [selectedExistingSalon, setSelectedExistingSalon] = useState('');

  const normalizeBooking = (b) => ({
    ...b,
    date:     (b.booking_date || b.date || '').slice(0, 10),
    time:     (b.booking_time || b.time || '').slice(0, 5),
    total:    Number(b.total) || 0,
    salon:    b.salon || { name: b.salon_name },
    employee: b.employee || (b.employee_name ? { name: b.employee_name } : null),
    services: b.services || (b.service_names?.filter(Boolean).map(name => ({ name })) || []),
    products: b.products || [],
    createdAt: b.created_at || b.createdAt,
  });

  const loadAll = useCallback(async () => {
    try {
      const [bData, uData, rData, aData, sData] = await Promise.all([
        apiFetch('/bookings'),
        apiFetch('/users'),
        apiFetch('/reviews'),
        apiFetch('/b2b/franchise'),
        apiFetch('/salons'),
      ]);
      setBookings((bData || []).map(normalizeBooking));
      setUsers(uData || []);
      setReviews(rData || []);
      setApplications(aData || []);
      setSalonsList(sData || []);
    } catch {}
  }, []);

  useEffect(() => { loadAll(); }, [loadAll]);

  const deleteSalon = async (salonName) => {
    try {
      const salonsResponse = await apiFetch('/salons');
      const salon = salonsResponse.find(s => s.name === salonName);
      if (!salon) {
        toast.info('To konto-widmo. Zostało pomyślnie ukryte.');
        setUsers(prev => prev.filter(u => u.salonName !== salonName && u.salon_name !== salonName));
        setDeleteConfirm(null);
        return;
      }
      await apiFetch(`/salons/${salon.id}`, { method: 'DELETE' });
      toast.success(`Salon "${salonName}" został usunięty`);
      setDeleteConfirm(null);
      setSalonsList(prev => prev.filter(s => s.id !== salon.id));
      setUsers(prev => prev.filter(u => u.salonName !== salonName && u.salon_name !== salonName));
      setBookings(prev => prev.filter(b => b.salon_name !== salonName && b.salon?.name !== salonName));
      setReviews(prev => prev.filter(r => r.salon_name !== salonName && r.salonName !== salonName));
    } catch (err) {
      console.error('Delete salon error:', err);
      toast.error('Błąd podczas usuwania salonu');
    }
  };

  const saveEditUser = async (e) => {
    e.preventDefault();
    if (!editUser.firstName || !editUser.lastName || !editUser.email) {
      toast.error('Wypełnij wymagane pola');
      return;
    }
    const cleanPhone = editUser.phone ? editUser.phone.replace(/\s/g, '') : '';
    if (cleanPhone && !/^(\+48)?[0-9]{9}$/.test(cleanPhone)) {
      toast.error('Niepoprawny numer telefonu. Użyj formatu: +48 123 456 789');
      return;
    }
    setSavingEditUser(true);
    try {
      await apiFetch(`/users/${editUser.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          firstName: editUser.firstName,
          lastName: editUser.lastName,
          email: editUser.email,
          phone: editUser.phone,
          role: editUser.role,
          ...(editUser.newPassword ? { password: editUser.newPassword } : {}),
        }),
      });
      toast.success('Dane użytkownika zaktualizowane!');
      setEditUser(null);
      loadAll();
    } catch (err) {
      toast.error(err.message || 'Błąd podczas aktualizacji');
    } finally {
      setSavingEditUser(false);
    }
  };

  const deleteUser = async (userId, userName) => {
    try {
      await apiFetch(`/users/${userId}`, { method: 'DELETE' });
      toast.success(`Użytkownik "${userName}" został usunięty`);
      setDeleteUserConfirm(null);
      loadAll();
    } catch (err) {
      console.error('Delete user error:', err);
      toast.error('Błąd podczas usuwania użytkownika');
    }
  };

  useEffect(() => {
    if (location.state?.openTab) {
      setActiveTab(location.state.openTab);
      window.history.replaceState({}, '');
    }
  }, [location.state]);

  useEffect(() => {
    const handler = (e) => setActiveTab(e.detail.tab);
    window.addEventListener('hairkus-open-tab', handler);
    return () => window.removeEventListener('hairkus-open-tab', handler);
  }, []);

  const salonUsers = salonsList.map(s => {
    const owner = users.find(u =>
      (u.role === 'salon' && (u.salonName === s.name || u.salon_name === s.name)) ||
      u.id === s.owner_id
    );
    return {
      id: s.id,
      ownerId: s.owner_id || null,
      salonName: s.name,
      salonCity: s.city,
      salonAddress: s.address,
      email: owner?.email || '-',
      phone: owner?.phone || '-',
      firstName: s.name,
    };
  });

  const franchiseeUsers = users.filter(u=>u.role==='franchisee');
  const pendingApps = applications.filter(a=>a.status==='pending');

  const getStats = () => {
    const revenue = bookings.filter(b => ['confirmed','completed'].includes(b.status)).reduce((s,b)=>s+(b.total||0),0);
    return {
      totalBookings: bookings.length,
      pendingBookings: bookings.filter(b=>b.status==='pending').length,
      revenue,
      clients: users.filter(u=>u.role==='client').length,
      salons: salonsList.length,
      avgRating: reviews.length ? (reviews.reduce((s,r)=>s+r.rating,0)/reviews.length).toFixed(1) : '-',
    };
  };

  const getSalonStats = (salonName) => {
    const sb = bookings.filter(b=>b.salon_name===salonName);
    const rev = sb.filter(b=>['confirmed','completed'].includes(b.status)).reduce((s,b)=>s+(b.total||0),0);
    const rev30 = sb.filter(b=>{
      const d = new Date(b.created_at); const now=new Date();
      return ['confirmed','completed'].includes(b.status) && (now-d)<30*86400000;
    }).reduce((s,b)=>s+(b.total||0),0);
    const sRev = reviews.filter(r=>r.salon_name===salonName);
    const avgR = sRev.length ? (sRev.reduce((s,r)=>s+r.rating,0)/sRev.length).toFixed(1) : '-';
    const thisMonth = sb.filter(b=>{
      const d = new Date(b.date); const now=new Date();
      return d.getMonth()===now.getMonth() && d.getFullYear()===now.getFullYear();
    }).length;
    return { total: sb.length, revenue: rev, revenue30: rev30, avg: avgR, reviews: sRev.length, pending: sb.filter(b=>b.status==='pending').length, thisMonth };
  };

  const salonNames = [...new Set(bookings.map(b=>b.salon_name).filter(Boolean))].sort();

  const filteredBookings = bookings.filter(b=>{
    if (filterSalon && b.salon_name!==filterSalon) return false;
    if (filterStatus && b.status!==filterStatus) return false;
    if (filterDate && b.booking_date!==filterDate) return false;
    if (searchClient && !b.email?.toLowerCase().includes(searchClient.toLowerCase())) return false;
    return true;
  }).sort((a,b)=>{
    if (sortBy==='date_desc') return new Date(b.booking_date+' '+b.booking_time)-new Date(a.booking_date+' '+a.booking_time);
    if (sortBy==='date_asc')  return new Date(a.booking_date+' '+a.booking_time)-new Date(b.booking_date+' '+b.booking_time);
    if (sortBy==='salon')     return (a.salon?.name||'').localeCompare(b.salon?.name||'');
    if (sortBy==='price_desc')return (b.total||0)-(a.total||0);
    if (sortBy==='price_asc') return (a.total||0)-(b.total||0);
    if (sortBy==='created')   return new Date(b.created_at || b.createdAt)-new Date(a.created_at || a.createdAt);
    return 0;
  });

  const filteredReviews = reviews.filter(r=>{
    if (filterReviewSalon && r.salon_name!==filterReviewSalon) return false;
    if (filterRating && r.rating!==parseInt(filterRating)) return false;
    return true;
  });

  const validUsers = users.filter(u => u.role !== 'salon' || salonsList.some(s => s.name === (u.salonName || u.salon_name)));
  const filteredUsers = validUsers.filter(u=>{
    if (filterRole && u.role!==filterRole) return false;
    if (searchUser) {
      const q=searchUser.toLowerCase();
      if (!`${u.firstName || u.first_name || ''} ${u.lastName || u.last_name || ''} ${u.email}`.toLowerCase().includes(q)) return false;
    }
    return true;
  });

  const statusColors = { pending:'#f59e0b', confirmed:'#10b981', rejected:'#ef4444', completed:'#6366f1', cancelled:'#9ca3af' };
  const statusLabels = { pending:'Oczekuje', confirmed:'Potwierdzona', rejected:'Odrzucona', completed:'Zrealizowana', cancelled:'Anulowana' };
  const statusIcons  = { pending:'pending', confirmed:'confirmed', rejected:'rejected', completed:'check', cancelled:'cancelled' };

  const stats = getStats();

  const salonsWithoutAccount = salonsList.filter(s =>
    !users.some(u => u.role === 'salon' && (u.salonName === s.name || u.salon_name === s.name))
  );

  const handleAddUser = async (e) => {
    e.preventDefault();
    if (!newUser.firstName || !newUser.lastName || !newUser.email || !newUser.password) {
      toast.error('Wypełnij wszystkie wymagane pola');
      return;
    }

    if (users.some(u => u.email === newUser.email)) {
      toast.error('Użytkownik z tym emailem już istnieje');
      return;
    }

    if (newUser.phone) {
      let phoneDigits = newUser.phone.replace(/\D/g, '');
      if (phoneDigits.startsWith('48')) phoneDigits = phoneDigits.substring(2);
      if (phoneDigits.length !== 9) {
        toast.error('Numer telefonu musi mieć 9 cyfr');
        return;
      }
    }

    if (newUser.role === 'salon') {
      if (salonMode === 'existing') {
        if (!selectedExistingSalon) { toast.error('Wybierz salon z listy'); return; }
        const salon = salonsList.find(s => s.name === selectedExistingSalon);
        if (salon) {
          newUser.salonName = salon.name;
          newUser.salonCity = salon.city || '';
          newUser.salonAddress = salon.address || '';
        }
      } else {
        if (!newUser.salonName) { toast.error('Podaj nazwę salonu'); return; }
      }
    }

    setSavingUser(true);
    try {
      await apiFetch('/auth/register', {
        method: 'POST',
        body: JSON.stringify(newUser),
      });
      await loadAll();
      setNewUser(EMPTY_USER);
      setSelectedExistingSalon('');
      setSalonMode('existing');
      setShowAddUser(false);
      toast.success(`Konto ${ROLE_LABELS[newUser.role]} "${newUser.firstName} ${newUser.lastName}" zostało utworzone!`);
    } catch (err) {
      toast.error(err.message || 'Błąd podczas tworzenia konta');
    } finally {
      setSavingUser(false);
    }
  };

  const tabs = [
    { id:'overview',      icon:'overview',     label:'Przegląd' },
    { id:'bookings',      icon:'calendar',     label:`Rezerwacje (${bookings.length})` },
    { id:'salons',        icon:'scissors',     label:`Salony (${salonsList.length})` },
    { id:'applications',  icon:'application',  label:`Wnioski${pendingApps.length ? ` (${pendingApps.length})` : ''}` },
    { id:'b2b',           icon:'package',      label:'B2B' },
    { id:'trainings',     icon:'staff',        label:'Szkolenia' },
    { id:'users',         icon:'users',        label:'Użytkownicy' },
    { id:'reviews',       icon:'star',         label:`Opinie (${reviews.length})` },
    { id:'notifications', icon:'notification', label:'Powiadomienia' },
    { id:'report',        icon:'money',        label:'Raport finansowy' },
    { id:'messages',      icon:'chat',         label:'Wiadomości', getMsgCount: () => chatUnread },
  ];

  return (
    <div className="dashboard-container">
      <div className="dashboard-wrapper">
        <div className="dashboard-header">
          <h1>Panel Administratora</h1>
          <p>Zarządzaj całą siecią HAIRKUS</p>
        </div>

        <div className="admin-tabs">
          {tabs.map(t => {
            const msgCount = t.getMsgCount ? t.getMsgCount() : 0;
            const isNotifications = t.id === 'notifications';
            const showNotifBadge = isNotifications && activeTab !== 'notifications' && notifUnread > 0;
            const isMessages = t.id === 'messages';
            return (
              <button
                key={t.id}
                className={`admin-tab ${activeTab===t.id ? 'active' : ''}`}
                onClick={() => setActiveTab(t.id)}
                style={(isNotifications || isMessages) ? {position:'relative'} : {}}>
                <Icon name={t.icon} style={{marginRight:'7px'}} />
                {isNotifications ? 'Powiadomienia' : t.label}
                {msgCount > 0 && <span className="tab-unread-badge">{msgCount > 9 ? '9+' : msgCount}</span>}
                {showNotifBadge && <span className="tab-unread-badge">{notifUnread > 9 ? '9+' : notifUnread}</span>}
              </button>
            );
          })}
        </div>

        {/* PRZEGLĄD */}
        {activeTab === 'overview' && (
          <div className="dashboard-content-single">
            <div className="stats-row">
              <div className="stat-card"><div className="stat-icon"><Icon name="calendar" /></div><div className="stat-content"><h3>{stats.totalBookings}</h3><p>Rezerwacje</p></div></div>
              <div className="stat-card highlight-pending"><div className="stat-icon"><Icon name="pending" /></div><div className="stat-content"><h3>{stats.pendingBookings}</h3><p>Oczekujące</p></div></div>
              <div className="stat-card highlight-revenue"><div className="stat-icon"><Icon name="money" /></div><div className="stat-content"><h3>{stats.revenue.toLocaleString('pl-PL')} zł</h3><p>Przychód</p></div></div>
              <div className="stat-card"><div className="stat-icon"><Icon name="users" /></div><div className="stat-content"><h3>{stats.clients}</h3><p>Klienci</p></div></div>
              <div className="stat-card"><div className="stat-icon"><Icon name="scissors" /></div><div className="stat-content"><h3>{stats.salons}</h3><p>Salony</p></div></div>
              <div className="stat-card"><div className="stat-icon"><Icon name="star" /></div><div className="stat-content"><h3>{stats.avgRating}</h3><p>Śr. ocena</p></div></div>
            </div>

            <div className="section-heading">
              <div className="section-heading-left">
                <div className="section-heading-icon"><Icon name="scissors" color="white" /></div>
                <div>
                  <h2>Statystyki salonów</h2>
                  <span>{salonsList.length} salonów w sieci</span>
                </div>
              </div>
              <button className="section-heading-btn" onClick={() => setActiveTab('salons')}>
                Zobacz wszystkie <Icon name="chevron-right" style={{marginLeft:'6px'}} />
              </button>
            </div>
            <div className="salon-stats-grid">
              {salonUsers.map(s => {
                const ss = getSalonStats(s.salonName);
                return (
                  <div key={s.id} className="salon-stat-card" onClick={() => setSelectedSalonDetail(s)}>
                    <div className="salon-stat-header">
                      <div className="salon-stat-avatar">
                        <Icon name="scissors" size="lg" color="white" />
                      </div>
                      <div className="salon-stat-info">
                        <h4>{s.salonName}</h4>
                        <span className="salon-stat-city">
                          <Icon name="location" style={{marginRight:'4px',fontSize:'0.85em'}} />
                          {s.salonCity || '-'}
                        </span>
                      </div>
                      <div className="salon-stat-arrow">
                        <Icon name="chevron-right" color="#bbb" />
                      </div>
                    </div>
                    <div className="salon-stat-metrics">
                      <div className="salon-metric">
                        <div className="salon-metric-icon blue"><Icon name="calendar" color="#1e3c72" /></div>
                        <span><strong>{ss.total}</strong><small>Rezerwacje</small></span>
                      </div>
                      <div className="salon-metric">
                        <div className="salon-metric-icon amber"><Icon name="pending" color="#d97706" /></div>
                        <span><strong>{ss.pending}</strong><small>Oczekujące</small></span>
                      </div>
                      <div className="salon-metric">
                        <div className="salon-metric-icon green"><Icon name="money" color="#059669" /></div>
                        <span><strong>{ss.revenue.toLocaleString('pl-PL')} zł</strong><small>Przychód</small></span>
                      </div>
                      <div className="salon-metric">
                        <div className="salon-metric-icon yellow"><Icon name="star" color="#d97706" /></div>
                        <span><strong>{ss.avg}</strong><small>{ss.reviews} opinii</small></span>
                      </div>
                    </div>
                  </div>
                );
              })}
              {salonUsers.length === 0 && (
                <div className="empty-state" style={{gridColumn:'1/-1'}}>
                  <div className="empty-icon" style={{fontSize:'2.5em'}}><Icon name="scissors" color="#ccc" /></div>
                  <p>Brak salonów w sieci</p>
                </div>
              )}
            </div>

            <div className="features-grid" style={{marginTop:'20px'}}>
              <div className="feature-card">
                <h3><Icon name="service" style={{marginRight:'8px'}} />Top usługi</h3>
                {(() => {
                  const counts = {};
                  bookings.forEach(b=>b.services?.forEach(s=>{counts[s.name]=(counts[s.name]||0)+1;}));
                  const sorted = Object.entries(counts).sort((a,b)=>b[1]-a[1]).slice(0,5);
                  return sorted.length ? (
                    <div className="top-list">{sorted.map(([name,count],i)=>(
                      <div key={name} className="top-item">
                        <span className="top-rank">#{i+1}</span>
                        <span className="top-name">{name}</span>
                        <span className="top-count">{count}x</span>
                      </div>
                    ))}</div>
                  ) : <p className="no-data">Brak danych</p>;
                })()}
              </div>
              <div className="feature-card">
                <h3><Icon name="franchisee" style={{marginRight:'8px'}} />Franczyzobiorcy</h3>
                {franchiseeUsers.length ? (
                  <div className="top-list">{franchiseeUsers.map(f=>(
                    <div key={f.id} className="top-item">
                      <span className="top-name">{f.firstName} {f.lastName}</span>
                      <span className="top-count">{f.email}</span>
                    </div>
                  ))}</div>
                ) : <p className="no-data">Brak franczyzobiorców</p>}
              </div>
            </div>
          </div>
        )}

        {/* REZERWACJE */}
        {activeTab === 'bookings' && (
          <div className="dashboard-content-single">
            <div className="dashboard-card-full">
              <div className="admin-filters-bar">
                <div className="filters-title">
                  <h2><Icon name="calendar" style={{marginRight:'10px'}} />Rezerwacje</h2>
                  <span className="count-badge">{filteredBookings.length} / {bookings.length}</span>
                </div>
                <div className="filters-grid">
                  <div className="filter-group">
                    <label><Icon name="search" style={{marginRight:'5px'}} />Klient</label>
                    <input type="text" placeholder="Email klienta..." value={searchClient} onChange={e=>setSearchClient(e.target.value)} className="filter-input" />
                  </div>
                  <div className="filter-group">
                    <label><Icon name="scissors" style={{marginRight:'5px'}} />Salon</label>
                    <select value={filterSalon} onChange={e=>setFilterSalon(e.target.value)} className="filter-select">
                      <option value="">Wszystkie salony</option>
                      {salonNames.map(n=><option key={n} value={n}>{n}</option>)}
                    </select>
                  </div>
                  <div className="filter-group">
                    <label><Icon name="filter" style={{marginRight:'5px'}} />Status</label>
                    <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} className="filter-select">
                      <option value="">Wszystkie statusy</option>
                      <option value="pending">Oczekuje</option>
                      <option value="confirmed">Potwierdzona</option>
                      <option value="completed">Zrealizowana</option>
                      <option value="rejected">Odrzucona</option>
                      <option value="cancelled">Anulowana</option>
                    </select>
                  </div>
                  <div className="filter-group">
                    <label><Icon name="calendar" style={{marginRight:'5px'}} />Data</label>
                    <input type="date" value={filterDate} onChange={e=>setFilterDate(e.target.value)} className="filter-input" />
                  </div>
                  <div className="filter-group">
                    <label><Icon name="sort" style={{marginRight:'5px'}} />Sortuj</label>
                    <select value={sortBy} onChange={e=>setSortBy(e.target.value)} className="filter-select">
                      <option value="date_desc">Data malejąco</option>
                      <option value="date_asc">Data rosnąco</option>
                      <option value="salon">Salon A-Z</option>
                      <option value="price_desc">Cena malejąco</option>
                      <option value="price_asc">Cena rosnąco</option>
                      <option value="created">Ostatnio dodane</option>
                    </select>
                  </div>
                  <div className="filter-group filter-reset">
                    <label>&nbsp;</label>
                    <button className="reset-filters-btn" onClick={()=>{setFilterSalon('');setFilterStatus('');setFilterDate('');setSearchClient('');setSortBy('date_desc');}}>
                      <Icon name="reset" style={{marginRight:'5px'}} />Resetuj
                    </button>
                  </div>
                </div>
              </div>
              {filteredBookings.length > 0 ? (
                <div className="table-container">
                  <table className="bookings-table">
                    <thead><tr><th>Klient</th><th>Salon</th><th>Data</th><th>Godzina</th><th>Pracownik</th><th>Usługi</th><th>Kwota</th><th>Status</th></tr></thead>
                    <tbody>
                      {filteredBookings.map(b => (
                        <tr key={b.id}>
                          <td><div className="salon-cell"><strong>{b.email}</strong><span className="address-small"><Icon name="phone" style={{marginRight:'4px'}} />{b.phone}</span></div></td>
                          <td><div className="salon-cell"><strong>{b.salon?.name}</strong><span className="address-small"><Icon name="location" style={{marginRight:'4px'}} />{b.salon?.address}</span></div></td>
                          <td><strong>{b.date}</strong></td>
                          <td><span className="time-badge"><Icon name="clock" style={{marginRight:'4px'}} />{b.time}</span></td>
                          <td>{b.employee?.name}</td>
                          <td><div className="services-cell">{b.services?.map((s,i)=><div key={i} className="service-tag">{s.name}</div>)}</div></td>
                          <td className="price-cell"><strong>{b.total} zł</strong></td>
                          <td>
                            <span className="status-badge" style={{background:(statusColors[b.status]||'#999')+'20',color:statusColors[b.status]||'#999'}}>
                              <Icon name={statusIcons[b.status]||'info'} style={{marginRight:'4px'}} />{statusLabels[b.status]||b.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="empty-state">
                  <div className="empty-icon" style={{fontSize:'3em'}}><Icon name="calendar" color="#ccc" /></div>
                  <h3>Brak rezerwacji</h3>
                  <button className="cta-button" onClick={()=>{setFilterSalon('');setFilterStatus('');setFilterDate('');setSearchClient('');setSortBy('date_desc');}}>Resetuj filtry</button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* SALONY */}
        {activeTab === 'salons' && (
          <div className="dashboard-content-single">
            <div className="dashboard-card-full">
              {(() => {
                const filtered = salonUsers.filter(s => {
                  if (!salonSearch) return true;
                  const search = salonSearch.toLowerCase();
                  return (
                    (s.salonName || '').toLowerCase().includes(search) ||
                    (s.salonCity || '').toLowerCase().includes(search) ||
                    (s.email || '').toLowerCase().includes(search)
                  );
                });
                return (
                  <>
                    <div className="admin-filters-bar">
                      <div className="filters-title">
                        <h2><Icon name="scissors" style={{marginRight:'10px'}} />Salony w sieci</h2>
                        <span className="count-badge">
                          {salonSearch ? `${filtered.length} z ${salonUsers.length}` : `${salonUsers.length} salonów`}
                        </span>
                      </div>
                      <div className="filters-actions">
                        <div style={{display:'flex',alignItems:'center',gap:'8px',background:'white',border:'2px solid #e5e7eb',borderRadius:'12px',padding:'10px 16px',minWidth:'350px',transition:'all 0.2s',boxShadow: salonSearch ? '0 4px 12px rgba(30,60,114,0.15)' : 'none'}}>
                          <Icon name="search" color={salonSearch ? '#1e3c72' : '#9ca3af'} />
                          <input
                            type="text"
                            placeholder="Szukaj po nazwie, mieście lub emailu..."
                            value={salonSearch}
                            onChange={e => setSalonSearch(e.target.value)}
                            style={{flex:1,border:'none',outline:'none',fontSize:'0.95em',background:'transparent'}}
                          />
                          {salonSearch && (
                            <button onClick={() => setSalonSearch('')} style={{background:'#f3f4f6',border:'none',borderRadius:'50%',width:'24px',height:'24px',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}
                              onMouseOver={e => e.currentTarget.style.background = '#e5e7eb'}
                              onMouseOut={e => e.currentTarget.style.background = '#f3f4f6'}>
                              <Icon name="close" color="#6b7280" />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    {filtered.length > 0 ? (
                      <div className="admin-cards-grid">
                        {filtered.map(s => {
                          const ss = getSalonStats(s.salonName);
                          return (
                            <div key={s.id} className="admin-salon-card">
                              <span className="active-badge"><Icon name="active" color="#10b981" style={{marginRight:'4px',fontSize:'0.6em'}} />Aktywny</span>
                              <div>
                                <div className="admin-salon-header">
                                  <h3>{s.salonName}</h3>
                                </div>
                                <p><Icon name="location" color="#1e3c72" style={{marginRight:'6px'}} />{s.salonCity || '-'}</p>
                                <p><Icon name="email" color="#666" style={{marginRight:'6px'}} />{s.email}</p>
                                <p><Icon name="phone" color="#666" style={{marginRight:'6px'}} />{s.phone || '-'}</p>
                              </div>
                              <div className="salon-card-footer">
                                <div className="salon-stats-mini">
                                  <span><Icon name="calendar" style={{marginRight:'4px'}} />Rezerwacje: <strong>{ss.total}</strong></span>
                                  <span><Icon name="money" style={{marginRight:'4px'}} />Przychód: <strong>{ss.revenue.toLocaleString('pl-PL')} zł</strong></span>
                                  <span><Icon name="star" color="#f59e0b" style={{marginRight:'4px'}} />Ocena: <strong>{ss.avg}</strong></span>
                                  <span><Icon name="calendar-day" style={{marginRight:'4px'}} />Ten miesiąc: <strong>{ss.thisMonth}</strong></span>
                                </div>
                                <div style={{display:'flex',gap:'8px'}}>
                                  <button className="chat-with-btn" disabled={!s.ownerId} title={!s.ownerId ? 'Salon nie ma jeszcze przypisanego konta' : undefined}
                                    onClick={()=>{setSelectedChat({id:s.ownerId,name:s.salonName,convId:`salon_${s.ownerId}_admin`});setActiveTab('messages');}}>
                                    <Icon name="message" style={{marginRight:'6px'}} />Napisz wiadomość
                                  </button>
                                  <button className="chat-with-btn" style={{background:'#ef4444',borderColor:'#dc2626'}}
                                    onClick={(e) => { e.stopPropagation(); setDeleteConfirm({ salonName: s.salonName }); }}>
                                    <Icon name="trash" style={{marginRight:'6px'}} />Usuń
                                  </button>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="empty-state">
                        <div className="empty-icon" style={{fontSize:'3em'}}><Icon name="search" color="#ccc" /></div>
                        <h3>Nie znaleziono salonów</h3>
                        <p>Brak salonów pasujących do wyszukiwania "{salonSearch}"</p>
                        <button className="cta-button" onClick={() => setSalonSearch('')}>
                          <Icon name="close" style={{marginRight:'7px'}} />Wyczyść wyszukiwanie
                        </button>
                      </div>
                    )}

                    {salonUsers.length === 0 && (
                      <div className="empty-state">
                        <div className="empty-icon" style={{fontSize:'3em'}}><Icon name="scissors" color="#ccc" /></div>
                        <h3>Brak salonów</h3>
                        <button className="cta-button" onClick={()=>{setActiveTab('users');setShowAddUser(true);}}>
                          <Icon name="user-plus" style={{marginRight:'7px'}} />Dodaj salon
                        </button>
                      </div>
                    )}
                  </>
                );
              })()}
            </div>
          </div>
        )}

        {/* WNIOSKI */}
        {activeTab === 'applications' && (
          <div className="dashboard-content-single">
            <div className="dashboard-card-full">
              <div className="admin-filters-bar">
                <div className="filters-title">
                  <h2><Icon name="application" style={{marginRight:'10px'}} />Wnioski franczyzowe</h2>
                  <span className="count-badge">{applications.length} wniosków</span>
                  {pendingApps.length > 0 && <span style={{padding:'4px 12px',background:'#fef3c7',color:'#92400e',borderRadius:'12px',fontSize:'0.85em',fontWeight:700}}><Icon name="pending" style={{marginRight:'4px'}} />{pendingApps.length} do rozpatrzenia</span>}
                </div>
              </div>
              {applications.length > 0 ? (
                <div className="table-container">
                  <table className="bookings-table">
                    <thead><tr><th>Franczyzobiorca</th><th>Nazwa salonu</th><th>Miasto / Adres</th><th>Powierzchnia</th><th>Data</th><th>Status</th><th>Akcje</th></tr></thead>
                    <tbody>
                      {applications.map(app => {
                        const sc = {pending:{bg:'#fef3c7',color:'#92400e',label:'Oczekuje'},approved:{bg:'#d1fae5',color:'#065f46',label:'Zaakceptowany'},rejected:{bg:'#fee2e2',color:'#991b1b',label:'Odrzucony'}}[app.status]||{bg:'#f3f4f6',color:'#555',label:app.status};
                        return (
                          <tr key={app.id}>
                            <td><div className="salon-cell"><strong>{app.user_name}</strong><span className="address-small">{app.user_email}</span></div></td>
                            <td><strong>{app.salon_name}</strong></td>
                            <td><div className="salon-cell"><strong>{app.city}</strong><span className="address-small"><Icon name="location" style={{marginRight:'4px'}} />{app.address}</span></div></td>
                            <td>{app.area ? `${app.area} m²` : '-'}</td>
                            <td>{new Date(app.submitted_at).toLocaleDateString('pl-PL')}</td>
                            <td><span style={{padding:'5px 12px',background:sc.bg,color:sc.color,borderRadius:'12px',fontSize:'0.85em',fontWeight:700}}>{sc.label}</span></td>
                            <td>{app.status==='pending' ? (
                              <div style={{display:'flex',gap:'8px'}}>
                                <button className="action-btn accept-btn" style={{padding:'6px 12px',fontSize:'0.85em'}} onClick={()=>{
                                  setApproveAppForm({ email: '', password: '' });
                                  setApproveAppModal(app);
                                }}><Icon name="check" style={{marginRight:'4px'}} />Akceptuj</button>
                                <button className="action-btn reject-btn" style={{padding:'6px 12px',fontSize:'0.85em'}} onClick={async ()=>{
                                  try {
                                    await apiFetch(`/b2b/franchise/${app.id}/status`, { method:'PATCH', body:JSON.stringify({status:'rejected'}) });
                                    toast.info(`Wniosek "${app.salon_name}" odrzucony.`);
                                    loadAll();
                                  } catch { toast.error('Błąd podczas odrzucania wniosku'); }
                                }}><Icon name="x" style={{marginRight:'4px'}} />Odrzuć</button>
                              </div>
                            ) : <span style={{color:'#aaa',fontSize:'0.85em'}}>Rozpatrzony</span>}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : <div className="empty-state"><div className="empty-icon" style={{fontSize:'3em'}}><Icon name="doc" color="#ccc" /></div><h3>Brak wniosków</h3></div>}
            </div>
          </div>
        )}

        {/* B2B */}
        {activeTab === 'b2b' && (
          <div className="dashboard-content-single">
            <AdminB2BPanel />
          </div>
        )}

        {/* SZKOLENIA */}
        {activeTab === 'trainings' && (
          <div className="dashboard-content-single">
            <AdminTrainingsPanel />
          </div>
        )}

        {/* UŻYTKOWNICY */}
        {activeTab === 'users' && (
          <div className="dashboard-content-single">
            <div className="dashboard-card-full">
              <div className="admin-filters-bar">
                <div className="filters-title">
                  <h2><Icon name="users" style={{marginRight:'10px'}} />Użytkownicy</h2>
                  <span className="count-badge">{filteredUsers.length} / {validUsers.length}</span>
                  <button className="cta-button" style={{marginLeft:'auto'}} onClick={()=>setShowAddUser(true)}>
                    <Icon name="user-plus" style={{marginRight:'7px'}} />Dodaj użytkownika
                  </button>
                </div>
                <div className="filters-grid">
                  <div className="filter-group">
                    <label><Icon name="search" style={{marginRight:'5px'}} />Szukaj</label>
                    <input type="text" placeholder="Imię, nazwisko, email..." value={searchUser} onChange={e=>setSearchUser(e.target.value)} className="filter-input" />
                  </div>
                  <div className="filter-group">
                    <label><Icon name="user" style={{marginRight:'5px'}} />Rola</label>
                    <select value={filterRole} onChange={e=>setFilterRole(e.target.value)} className="filter-select">
                      <option value="">Wszystkie role</option>
                      {ROLES.map(r=><option key={r} value={r}>{ROLE_LABELS[r]}</option>)}
                    </select>
                  </div>
                  <div className="filter-group filter-reset">
                    <label>&nbsp;</label>
                    <button className="reset-filters-btn" onClick={()=>{setFilterRole('');setSearchUser('');}}>
                      <Icon name="reset" style={{marginRight:'5px'}} />Resetuj
                    </button>
                  </div>
                </div>
              </div>
              <div className="table-container">
                <table className="bookings-table">
                  <thead><tr><th>Imię i nazwisko</th><th>Email</th><th>Rola</th><th>Telefon</th><th style={{textAlign:'center'}}>Rezerwacji</th><th style={{textAlign:'center'}}>Akcje</th></tr></thead>
                  <tbody>
                    {filteredUsers.map(u=>(
                      <tr key={u.id}>
                        <td><strong>{u.firstName || u.first_name} {u.lastName || u.last_name}</strong>{(u.salonName || u.salon_name) && <span className="address-small" style={{display:'block',marginTop:'2px'}}>{u.salonName || u.salon_name}</span>}</td>
                        <td>{u.email}</td>
                        <td>
                          <span className="role-badge" style={{background:{client:'#dbeafe',salon:'#d1fae5',admin:'#fce7f3',franchisee:'#ede9fe'}[u.role],color:{client:'#1d4ed8',salon:'#065f46',admin:'#9d174d',franchisee:'#5b21b6'}[u.role]}}>
                            <Icon name={ROLE_ICONS[u.role]||'user'} style={{marginRight:'5px'}} />{ROLE_LABELS[u.role]||u.role}
                          </span>
                        </td>
                        <td>{u.phone || '-'}</td>
                        <td><strong>{bookings.filter(b=>(b.userId||b.user_id)===u.id).length}</strong></td>
                        <td>
                          <div style={{display:'flex',gap:'6px',alignItems:'center',justifyContent:'center',width:'100%'}}>
                            <button onClick={() => setEditUser({
                              id: u.id,
                              firstName: u.firstName || u.first_name || '',
                              lastName: u.lastName || u.last_name || '',
                              email: u.email || '',
                              phone: u.phone || '',
                              role: u.role,
                              newPassword: '',
                            })}
                              style={{padding:'6px 12px',fontSize:'0.85em',background:'#dbeafe',color:'#1d4ed8',border:'1px solid #bfdbfe',borderRadius:'6px',cursor:'pointer',transition:'all 0.2s',display:'flex',alignItems:'center',gap:'6px'}}
                              onMouseOver={e => { e.currentTarget.style.background = '#bfdbfe'; }}
                              onMouseOut={e => { e.currentTarget.style.background = '#dbeafe'; }}>
                              <Icon name="edit" />Edytuj
                            </button>
                            <button onClick={() => setDeleteUserConfirm({ userId: u.id, userName: `${u.firstName || u.first_name} ${u.lastName || u.last_name}`, email: u.email })}
                              style={{padding:'6px 12px',fontSize:'0.85em',background:'#fee2e2',color:'#dc2626',border:'1px solid #fecaca',borderRadius:'6px',cursor:'pointer',transition:'all 0.2s',display:'flex',alignItems:'center',gap:'6px'}}
                              onMouseOver={e => { e.currentTarget.style.background = '#fecaca'; e.currentTarget.style.borderColor = '#dc2626'; }}
                              onMouseOut={e => { e.currentTarget.style.background = '#fee2e2'; e.currentTarget.style.borderColor = '#fecaca'; }}>
                              <Icon name="trash" />Usuń
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* OPINIE */}
        {activeTab === 'reviews' && (
          <div className="dashboard-content-single">
            <div className="dashboard-card-full">
              <div className="admin-filters-bar">
                <div className="filters-title">
                  <h2><Icon name="star" style={{marginRight:'10px'}} />Opinie klientów</h2>
                  <span className="count-badge">{filteredReviews.length} / {reviews.length}</span>
                </div>
                <div className="filters-grid">
                  <div className="filter-group">
                    <label><Icon name="scissors" style={{marginRight:'5px'}} />Salon</label>
                    <select value={filterReviewSalon} onChange={e=>setFilterReviewSalon(e.target.value)} className="filter-select">
                      <option value="">Wszystkie salony</option>
                      {[...new Set(reviews.map(r=>(r.salon_name || r.salonName)))].sort().map(n=><option key={n} value={n}>{n}</option>)}
                    </select>
                  </div>
                  <div className="filter-group">
                    <label><Icon name="star" style={{marginRight:'5px'}} />Ocena</label>
                    <select value={filterRating} onChange={e=>setFilterRating(e.target.value)} className="filter-select">
                      <option value="">Wszystkie oceny</option>
                      {[5,4,3,2,1].map(r=><option key={r} value={r}>{'★'.repeat(r)} ({r}/5)</option>)}
                    </select>
                  </div>
                  <div className="filter-group filter-reset">
                    <label>&nbsp;</label>
                    <button className="reset-filters-btn" onClick={()=>{setFilterReviewSalon('');setFilterRating('');}}>
                      <Icon name="reset" style={{marginRight:'5px'}} />Resetuj
                    </button>
                  </div>
                </div>
              </div>
              {filteredReviews.length > 0 ? (
                <div className="reviews-admin-list">
                  {filteredReviews.map(r=>(
                    <div key={r.id} className="review-admin-card">
                      <div className="review-admin-header">
                        <div><strong>{r.salon_name || r.salonName}</strong><span className="review-admin-date">{new Date(r.created_at || r.createdAt).toLocaleDateString('pl-PL')}</span></div>
                        <div className="stars-display">{'★'.repeat(r.rating)}{'☆'.repeat(5-r.rating)}<strong> {r.rating}/5</strong></div>
                      </div>
                      {r.comment && <p className="review-admin-comment">"{r.comment}"</p>}
                      <div className="review-categories">
                        {Object.entries(r.categories||{}).map(([key,val])=>val>0&&(
                          <span key={key} className="category-chip">
                            {key==='service'&&'Usługa'}{key==='cleanliness'&&'Czystość'}{key==='staff'&&'Obsługa'}{key==='atmosphere'&&'Atmosfera'}: {val}★
                          </span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              ) : <div className="empty-state"><div className="empty-icon" style={{fontSize:'3em'}}><Icon name="star-empty" color="#ccc" /></div><h3>Brak opinii</h3></div>}
            </div>
          </div>
        )}

        {/* WIADOMOŚCI */}
        {activeTab === 'messages' && (
          <div className="dashboard-content-single">
            <div className="admin-messages-layout">
              <div className="admin-messages-sidebar">
                <div className="messages-sidebar-header">
                  <Icon name="chat" style={{marginRight:'8px'}} />Rozmowy
                </div>
                {salonUsers.length > 0 && (
                  <div className="messages-group">
                    <div className="messages-group-label">
                      <Icon name="scissors" style={{marginRight:'6px',fontSize:'0.85em'}} />Salony
                    </div>
                    {salonUsers.filter(s => s.ownerId).map(s => {
                      const convId = `salon_${s.ownerId}_admin`;
                      const hasUnread = (unreadBreakdown[convId] || 0) > 0;
                      return (
                        <button key={s.ownerId}
                          className={`messages-conv-btn ${selectedChat?.id===s.ownerId ? 'active' : ''} ${hasUnread ? 'has-unread' : ''}`}
                          onClick={() => setSelectedChat({id:s.ownerId, name:s.salonName, convId})}>
                          <div className="conv-btn-avatar scissors">
                            <Icon name="scissors" color="white" />
                          </div>
                          <div className="conv-btn-info">
                            <span className="conv-btn-name">{s.salonName}</span>
                          </div>
                          {hasUnread && <span className="conv-unread-dot" />}
                        </button>
                      );
                    })}
                  </div>
                )}
                {franchiseeUsers.length > 0 && (
                  <div className="messages-group">
                    <div className="messages-group-label">
                      <Icon name="franchisee" style={{marginRight:'6px',fontSize:'0.85em'}} />Franczyzobiorcy
                    </div>
                    {franchiseeUsers.map(f => {
                      const convId = `franchisee_${f.id}_admin`;
                      const hasUnread = (unreadBreakdown[convId] || 0) > 0;
                      return (
                        <button key={f.id}
                          className={`messages-conv-btn ${selectedChat?.id===f.id ? 'active' : ''} ${hasUnread ? 'has-unread' : ''}`}
                          onClick={() => setSelectedChat({id:f.id, name:`${f.firstName} ${f.lastName}`, convId})}>
                          <div className="conv-btn-avatar franchisee">
                            <Icon name="franchisee" color="white" />
                          </div>
                          <div className="conv-btn-info">
                            <span className="conv-btn-name">{f.firstName} {f.lastName}</span>
                          </div>
                          {hasUnread && <span className="conv-unread-dot" />}
                        </button>
                      );
                    })}
                  </div>
                )}
                {salonUsers.length === 0 && franchiseeUsers.length === 0 && (
                  <div className="messages-empty-sidebar">
                    <Icon name="chat" color="#ccc" size="2x" />
                    <p>Brak rozmów</p>
                  </div>
                )}
              </div>
              <div className="admin-messages-chat">
                {selectedChat ? (
                  <>
                    <div className="admin-chat-header">
                      <Icon name={selectedChat.convId.startsWith('franchisee') ? 'franchisee' : 'scissors'} style={{marginRight:'10px', fontSize:'1.2em'}} />
                      <strong>{selectedChat.name}</strong>
                    </div>
                    <Chat conversationId={selectedChat.convId} recipientName={selectedChat.name} recipientRole={selectedChat.convId.startsWith('franchisee') ? 'Franczyzobiorca' : 'Salon'} />
                  </>
                ) : (
                  <div className="empty-state">
                    <div className="empty-icon" style={{fontSize:'3.5em'}}><Icon name="chat" color="#d1d5db" /></div>
                    <h3>Wybierz rozmowę</h3>
                    <p>Kliknij salon lub franczyzobiorcę z listy po lewej</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/*DODAJ UŻYTKOWNIKA */}
      {showAddUser && (
        <div className="chat-modal-overlay" onClick={()=>{setShowAddUser(false);setSalonMode('existing');setSelectedExistingSalon('');}}>
          <div className="add-user-modal" onClick={e=>e.stopPropagation()}>
            <div className="add-user-modal-header">
              <h2><Icon name="user-plus" style={{marginRight:'10px'}} />Nowy użytkownik</h2>
              <button className="review-close-btn" onClick={()=>{setShowAddUser(false);setSalonMode('existing');setSelectedExistingSalon('');}}><Icon name="close" /></button>
            </div>
            <form onSubmit={handleAddUser} className="add-user-form">
              <div className="add-user-role-select">
                {ROLES.map(r=>(
                  <button type="button" key={r} className={`role-select-btn ${newUser.role===r?'active':''}`}
                    onClick={()=>{setNewUser(u=>({...u,role:r}));setSalonMode('existing');setSelectedExistingSalon('');}}>
                    <Icon name={ROLE_ICONS[r]} size="lg" /><span>{ROLE_LABELS[r]}</span>
                  </button>
                ))}
              </div>
              <div className="profile-form-grid">
                <div className="profile-field"><label>Imię *</label><input value={newUser.firstName} onChange={e=>setNewUser(u=>({...u,firstName:e.target.value}))} required placeholder="Jan" /></div>
                <div className="profile-field"><label>Nazwisko *</label><input value={newUser.lastName} onChange={e=>setNewUser(u=>({...u,lastName:e.target.value}))} required placeholder="Kowalski" /></div>
                <div className="profile-field">
                  <label>Email *</label>
                  <input type="email" value={newUser.email} onChange={e=>setNewUser(u=>({...u,email:e.target.value}))} required placeholder="jan@example.com"
                    style={{borderColor: newUser.email && users.some(u=>u.email===newUser.email) ? '#ef4444' : ''}} />
                  {newUser.email && users.some(u=>u.email===newUser.email) && (
                    <small style={{color:'#ef4444',marginTop:'4px',display:'block'}}>❌ Ten email jest już zajęty</small>
                  )}
                </div>
                <div className="profile-field"><label>Hasło *</label><input type="password" value={newUser.password} onChange={e=>setNewUser(u=>({...u,password:e.target.value}))} required placeholder="min. 6 znaków" /></div>
                <div className="profile-field">
                  <label>Telefon</label>
                  <input value={newUser.phone} onChange={(e) => {
                    const input = e.target.value;
                    let digits = input.replace(/\D/g, '');
                    if (digits.startsWith('48')) digits = digits.substring(2);
                    if (digits.length > 9) digits = digits.substring(0, 9);
                    let formatted = '+48';
                    if (digits.length > 0) formatted += ' ' + digits.substring(0, 3);
                    if (digits.length > 3) formatted += ' ' + digits.substring(3, 6);
                    if (digits.length > 6) formatted += ' ' + digits.substring(6, 9);
                    setNewUser(u => ({...u, phone: formatted}));
                  }} placeholder="+48 123 456 789" />
                </div>
              </div>

              {/* SEKCJA SALON*/}
              {newUser.role === 'salon' && (
                <div style={{marginTop:'16px',paddingTop:'16px',borderTop:'2px solid #f3f4f6'}}>
                  {/* Wybór trybu */}
                  <div style={{display:'flex',gap:'10px',marginBottom:'16px'}}>
                    <button type="button"
                      onClick={()=>{setSalonMode('existing');setSelectedExistingSalon('');setNewUser(u=>({...u,salonName:'',salonCity:'',salonAddress:''}));}}
                      style={{flex:1,padding:'12px',border:`2px solid ${salonMode==='existing'?'#1e3c72':'#e0e0e0'}`,borderRadius:'10px',background:salonMode==='existing'?'rgba(30,60,114,0.06)':'white',color:salonMode==='existing'?'#1e3c72':'#666',fontWeight:600,cursor:'pointer',transition:'all 0.2s',display:'flex',alignItems:'center',justifyContent:'center',gap:'8px'}}>
                      <Icon name="scissors" />Przypisz istniejący salon
                    </button>
                    <button type="button"
                      onClick={()=>{setSalonMode('new');setSelectedExistingSalon('');}}
                      style={{flex:1,padding:'12px',border:`2px solid ${salonMode==='new'?'#1e3c72':'#e0e0e0'}`,borderRadius:'10px',background:salonMode==='new'?'rgba(30,60,114,0.06)':'white',color:salonMode==='new'?'#1e3c72':'#666',fontWeight:600,cursor:'pointer',transition:'all 0.2s',display:'flex',alignItems:'center',justifyContent:'center',gap:'8px'}}>
                      <Icon name="add" />Utwórz nowy salon
                    </button>
                  </div>

                  {/* Istniejący salon */}
                  {salonMode === 'existing' && (
                    <div>
                      {salonsWithoutAccount.length > 0 ? (
                        <div className="profile-field">
                          <label><Icon name="salon" style={{marginRight:'5px'}} />Wybierz salon *</label>
                          <select value={selectedExistingSalon} onChange={e => {
                            setSelectedExistingSalon(e.target.value);
                            const salon = salonsList.find(s => s.name === e.target.value);
                            if (salon) setNewUser(u => ({...u, salonName: salon.name, salonCity: salon.city||'', salonAddress: salon.address||''}));
                          }} style={{width:'100%',padding:'12px',border:'2px solid #e0e0e0',borderRadius:'8px',fontSize:'1em',background:'white'}}>
                            <option value="">Wybierz salon...</option>
                            {salonsWithoutAccount.map(s => (
                              <option key={s.id} value={s.name}>{s.name}{s.city ? ` - ${s.city}` : ''}</option>
                            ))}
                          </select>
                          {selectedExistingSalon && (
                            <div style={{marginTop:'10px',padding:'12px',background:'#f0f9ff',borderRadius:'8px',border:'1.5px solid #bae6fd',fontSize:'0.9em',color:'#0369a1'}}>
                              <Icon name="location" style={{marginRight:'6px'}} />
                              {salonsList.find(s=>s.name===selectedExistingSalon)?.city} - {salonsList.find(s=>s.name===selectedExistingSalon)?.address || 'brak adresu'}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div style={{padding:'16px',background:'#fef3c7',borderRadius:'10px',color:'#92400e',fontSize:'0.9em'}}>
                          <Icon name="warning" style={{marginRight:'8px'}} />
                          Wszystkie salony mają już przypisane konta. Użyj trybu "Utwórz nowy salon".
                        </div>
                      )}
                    </div>
                  )}

                  {/* Nowy salon */}
                  {salonMode === 'new' && (
                    <div className="profile-form-grid">
                      <div className="profile-field"><label><Icon name="salon" style={{marginRight:'5px'}} />Nazwa salonu *</label><input value={newUser.salonName} onChange={e=>setNewUser(u=>({...u,salonName:e.target.value}))} required placeholder="HAIRKUS Rzeszów" /></div>
                      <div className="profile-field"><label><Icon name="location" style={{marginRight:'5px'}} />Miasto</label><input value={newUser.salonCity} onChange={e=>setNewUser(u=>({...u,salonCity:e.target.value}))} placeholder="Rzeszów" /></div>
                      <div className="profile-field" style={{gridColumn:'1/-1'}}><label>Adres</label><input value={newUser.salonAddress} onChange={e=>setNewUser(u=>({...u,salonAddress:e.target.value}))} placeholder="ul. Przykładowa 1" /></div>
                    </div>
                  )}
                </div>
              )}

              <div className="profile-actions" style={{marginTop:'24px'}}>
                <button type="button" className="profile-cancel-btn" onClick={()=>{setShowAddUser(false);setSalonMode('existing');setSelectedExistingSalon('');}}>Anuluj</button>
                <button type="submit" className="profile-save-btn" disabled={savingUser}>
                  <Icon name={savingUser?'pending':'user-plus'} style={{marginRight:'7px'}} />
                  {savingUser ? 'Tworzenie...' : `Utwórz konto ${ROLE_LABELS[newUser.role]}`}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* SZCZEGÓŁY SALONU */}
      {selectedSalonDetail && (() => {
        const s = selectedSalonDetail;
        const ss = getSalonStats(s.salonName);
        const salonBookings = bookings.filter(b=>b.salon?.name===s.salonName).slice(0,5);
        const salonRevs = reviews.filter(r=>(r.salon_name || r.salonName)===s.salonName);
        return (
          <div className="chat-modal-overlay" onClick={()=>setSelectedSalonDetail(null)}>
            <div className="salon-detail-modal" onClick={e=>e.stopPropagation()}>
              <div className="salon-detail-header">
                <div>
                  <h2>{s.salonName}</h2>
                  <p>
                    <span style={{display:'inline-flex',alignItems:'center',background:'rgba(255,255,255,0.18)',borderRadius:'8px',padding:'4px 10px',marginTop:'4px',fontSize:'0.88em'}}>
                      <Icon name="location" style={{marginRight:'7px',flexShrink:0}} />
                      {s.salonCity}{s.salonAddress ? `, ${s.salonAddress}` : ''}
                    </span>
                  </p>
                </div>
                <button className="review-close-btn" onClick={()=>setSelectedSalonDetail(null)}><Icon name="close" /></button>
              </div>
              <div className="salon-detail-stats">
                {[
                  {icon:'calendar',label:'Rezerwacje',val:ss.total},
                  {icon:'pending',label:'Oczekujące',val:ss.pending},
                  {icon:'money',label:'Przychód',val:`${ss.revenue.toLocaleString('pl-PL')} zł`},
                  {icon:'calendar-day',label:'Ten miesiąc',val:ss.thisMonth},
                  {icon:'star',label:'Śr. ocena',val:ss.avg},
                  {icon:'review',label:'Opinie',val:ss.reviews},
                ].map(m=>(
                  <div key={m.label} className="detail-metric">
                    <Icon name={m.icon} size="lg" color="#1e3c72" />
                    <div><strong>{m.val}</strong><small>{m.label}</small></div>
                  </div>
                ))}
              </div>
              <h4 style={{margin:'20px 0 12px',color:'#1e3c72'}}><Icon name="calendar" style={{marginRight:'8px'}} />Ostatnie rezerwacje</h4>
              {salonBookings.length > 0 ? salonBookings.map(b=>(
                <div key={b.id} className="detail-booking-row">
                  <span>{b.date} {b.time}</span><span>{b.email}</span><span>{b.total} zł</span>
                  <span className="status-badge" style={{background:(statusColors[b.status]||'#999')+'20',color:statusColors[b.status]||'#999',fontSize:'0.8em'}}>{statusLabels[b.status]}</span>
                </div>
              )) : <p style={{color:'#999'}}>Brak rezerwacji</p>}
              {salonRevs.length > 0 && <>
                <h4 style={{margin:'20px 0 12px',color:'#1e3c72'}}><Icon name="star" color="#f59e0b" style={{marginRight:'8px'}} />Ostatnie opinie</h4>
                {salonRevs.slice(0,3).map(r=>(
                  <div key={r.id} className="detail-review-row">
                    <span className="stars-mini">{'★'.repeat(r.rating)}{'☆'.repeat(5-r.rating)}</span>
                    <span>{r.comment || '(bez komentarza)'}</span>
                  </div>
                ))}
              </>}
              <div style={{display:'flex',gap:'12px',marginTop:'20px'}}>
                <button className="chat-with-btn" disabled={!s.ownerId} title={!s.ownerId ? 'Salon nie ma jeszcze przypisanego konta' : undefined}
                  onClick={()=>{setSelectedSalonDetail(null);setSelectedChat({id:s.ownerId,name:s.salonName,convId:`salon_${s.ownerId}_admin`});setActiveTab('messages');}}>
                  <Icon name="message" style={{marginRight:'6px'}} />Napisz wiadomość
                </button>
              </div>
            </div>
          </div>
        );
      })()}

      {/* POWIADOMIENIA */}
      {activeTab === 'notifications' && (
        <AdminPushPanel user={user} users={validUsers} />
      )}

      {/* RAPORT FINANSOWY */}
      {activeTab === 'report' && (
        <div className="dashboard-content-single" style={{maxWidth:'900px', margin:'0 auto'}}>
          <FinancialReport bookings={bookings} users={users} reviews={reviews} />
        </div>
      )}

      {/* USUŃ SALON */}
      {deleteConfirm && (
        <div className="modal-overlay" onClick={() => setDeleteConfirm(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{maxWidth:'450px',padding:'32px'}}>
            <div style={{textAlign:'center',marginBottom:'28px'}}>
              <div style={{width:'80px',height:'80px',margin:'0 auto 20px',borderRadius:'50%',background:'#fee2e2',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <Icon name="trash" color="#dc2626" size="2x" />
              </div>
              <h2 style={{margin:'0 0 12px',fontSize:'1.75em',color:'#111',fontWeight:700}}>Usuń salon?</h2>
              <p style={{color:'#6b7280',margin:'0 0 8px',fontSize:'1.05em'}}>Czy na pewno chcesz usunąć salon:</p>
              <p style={{color:'#111',margin:0,fontSize:'1.15em',fontWeight:600,padding:'12px 20px',background:'#f9fafb',borderRadius:'8px',border:'2px solid #e5e7eb'}}>{deleteConfirm.salonName}</p>
            </div>
            <div style={{display:'flex',gap:'12px',marginTop:'28px'}}>
              <button onClick={() => setDeleteConfirm(null)} style={{flex:1,padding:'14px 24px',fontSize:'1em',fontWeight:600,border:'2px solid #e5e7eb',borderRadius:'10px',background:'white',color:'#374151',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:'8px'}}
                onMouseOver={e => { e.currentTarget.style.background = '#f9fafb'; }}
                onMouseOut={e => { e.currentTarget.style.background = 'white'; }}>
                <Icon name="close" />Anuluj
              </button>
              <button onClick={() => deleteSalon(deleteConfirm.salonName)} style={{flex:1,padding:'14px 24px',fontSize:'1em',fontWeight:600,border:'2px solid #dc2626',borderRadius:'10px',background:'#dc2626',color:'white',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:'8px'}}
                onMouseOver={e => { e.currentTarget.style.background = '#b91c1c'; }}
                onMouseOut={e => { e.currentTarget.style.background = '#dc2626'; }}>
                <Icon name="trash" />Usuń salon
              </button>
            </div>
          </div>
        </div>
      )}

      {/* EDYTUJ UŻYTKOWNIKA */}
      {editUser && (
        <div className="modal-overlay" onClick={() => setEditUser(null)}>
          <div className="add-user-modal" onClick={e => e.stopPropagation()}>
            <div className="add-user-modal-header">
              <h2><Icon name="edit" style={{marginRight:'10px'}} />Edytuj użytkownika</h2>
              <button className="review-close-btn" onClick={() => setEditUser(null)}><Icon name="close" /></button>
            </div>
            <form onSubmit={saveEditUser} className="add-user-form">
              <div className="add-user-role-select">
                {ROLES.map(r => (
                  <button type="button" key={r} className={`role-select-btn ${editUser.role===r?'active':''}`}
                    onClick={() => setEditUser(u => ({...u, role: r}))}>
                    <Icon name={ROLE_ICONS[r]} size="lg" /><span>{ROLE_LABELS[r]}</span>
                  </button>
                ))}
              </div>
              <div className="profile-form-grid">
                <div className="profile-field">
                  <label>Imię *</label>
                  <input value={editUser.firstName} onChange={e => setEditUser(u => ({...u, firstName: e.target.value}))} required placeholder="Jan" />
                </div>
                <div className="profile-field">
                  <label>Nazwisko *</label>
                  <input value={editUser.lastName} onChange={e => setEditUser(u => ({...u, lastName: e.target.value}))} required placeholder="Kowalski" />
                </div>
                <div className="profile-field">
                  <label>Email *</label>
                  <input type="email" value={editUser.email} onChange={e => setEditUser(u => ({...u, email: e.target.value}))} required />
                </div>
                <div className="profile-field">
                  <label>Telefon</label>
                  <input value={editUser.phone} onChange={(e) => {
                    const input = e.target.value;
                    let digits = input.replace(/\D/g, '');
                    if (digits.startsWith('48')) digits = digits.substring(2);
                    if (digits.length > 9) digits = digits.substring(0, 9);
                    let formatted = '+48';
                    if (digits.length > 0) formatted += ' ' + digits.substring(0, 3);
                    if (digits.length > 3) formatted += ' ' + digits.substring(3, 6);
                    if (digits.length > 6) formatted += ' ' + digits.substring(6, 9);
                    setEditUser(u => ({...u, phone: formatted}));
                  }} placeholder="+48 123 456 789" />
                </div>
                <div className="profile-field" style={{gridColumn:'1/-1'}}>
                  <label>Nowe hasło <span style={{color:'#9ca3af',fontWeight:400}}>(zostaw puste żeby nie zmieniać)</span></label>
                  <input type="password" value={editUser.newPassword} onChange={e => setEditUser(u => ({...u, newPassword: e.target.value}))} placeholder="min. 6 znaków" />
                </div>
              </div>
              <div className="profile-actions" style={{marginTop:'24px'}}>
                <button type="button" className="profile-cancel-btn" onClick={() => setEditUser(null)}>Anuluj</button>
                <button type="submit" className="profile-save-btn" disabled={savingEditUser}>
                  <Icon name={savingEditUser?'pending':'check'} style={{marginRight:'7px'}} />
                  {savingEditUser ? 'Zapisywanie...' : 'Zapisz zmiany'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* USUŃ UŻYTKOWNIKA */}
      {deleteUserConfirm && (
        <div className="modal-overlay" onClick={() => setDeleteUserConfirm(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{maxWidth:'450px',padding:'32px'}}>
            <div style={{textAlign:'center',marginBottom:'28px'}}>
              <div style={{width:'80px',height:'80px',margin:'0 auto 20px',borderRadius:'50%',background:'#fee2e2',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <Icon name="trash" color="#dc2626" size="2x" />
              </div>
              <h2 style={{margin:'0 0 12px',fontSize:'1.75em',color:'#111',fontWeight:700}}>Usuń użytkownika?</h2>
              <p style={{color:'#6b7280',margin:'0 0 8px',fontSize:'1.05em'}}>Czy na pewno chcesz usunąć użytkownika:</p>
              <p style={{color:'#111',margin:0,fontSize:'1.15em',fontWeight:600,padding:'12px 20px',background:'#f9fafb',borderRadius:'8px',border:'2px solid #e5e7eb'}}>{deleteUserConfirm.userName}</p>
              <p style={{color:'#9ca3af',margin:'8px 0 0',fontSize:'0.9em'}}>{deleteUserConfirm.email}</p>
            </div>
            <div style={{display:'flex',gap:'12px',marginTop:'28px'}}>
              <button onClick={() => setDeleteUserConfirm(null)} style={{flex:1,padding:'14px 24px',fontSize:'1em',fontWeight:600,border:'2px solid #e5e7eb',borderRadius:'10px',background:'white',color:'#374151',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:'8px'}}
                onMouseOver={e => { e.currentTarget.style.background = '#f9fafb'; }}
                onMouseOut={e => { e.currentTarget.style.background = 'white'; }}>
                <Icon name="close" />Anuluj
              </button>
              <button onClick={() => deleteUser(deleteUserConfirm.userId, deleteUserConfirm.userName)} style={{flex:1,padding:'14px 24px',fontSize:'1em',fontWeight:600,border:'2px solid #dc2626',borderRadius:'10px',background:'#dc2626',color:'white',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:'8px'}}
                onMouseOver={e => { e.currentTarget.style.background = '#b91c1c'; }}
                onMouseOut={e => { e.currentTarget.style.background = '#dc2626'; }}>
                <Icon name="trash" />Usuń użytkownika
              </button>
            </div>
          </div>
        </div>
      )}

      {/*ZATWIERDŹ WNIOSEK FRANCZYZOWY */}
      {approveAppModal && (
        <div className="modal-overlay" onClick={() => !approvingApp && setApproveAppModal(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h3><Icon name="check" style={{marginRight:'8px',color:'#10b981'}} />Akceptacja wniosku - {approveAppModal.salon_name}</h3>
            <p>Załóż dane logowania do nowego, osobnego konta salonu. Franczyzobiorca zachowa swoje dotychczasowe konto.</p>
            <form onSubmit={async (e) => {
              e.preventDefault();
              if (!approveAppForm.email || !approveAppForm.password) {
                toast.error('Podaj email i hasło'); return;
              }
              if (approveAppForm.password.length < 6) {
                toast.error('Hasło musi mieć minimum 6 znaków'); return;
              }
              if (users.some(u => u.email === approveAppForm.email)) {
                toast.error('Ten email jest już zajęty'); return;
              }
              setApprovingApp(true);
              try {
                await apiFetch(`/b2b/franchise/${approveAppModal.id}/status`, {
                  method: 'PATCH',
                  body: JSON.stringify({ status: 'approved', email: approveAppForm.email, password: approveAppForm.password }),
                });
                toast.success(`Wniosek "${approveAppModal.salon_name}" zaakceptowany, konto salonu utworzone!`);
                setApproveAppModal(null);
                loadAll();
              } catch (err) {
                toast.error(err.message || 'Błąd podczas akceptacji wniosku');
              } finally {
                setApprovingApp(false);
              }
            }}>
              <div className="profile-field" style={{marginBottom:'14px'}}>
                <label>Email salonu *</label>
                <input type="email" required value={approveAppForm.email}
                  onChange={e => setApproveAppForm(f => ({ ...f, email: e.target.value }))}
                  placeholder="salon@example.com" />
              </div>
              <div className="profile-field" style={{marginBottom:'14px'}}>
                <label>Hasło *</label>
                <input type="password" required value={approveAppForm.password}
                  onChange={e => setApproveAppForm(f => ({ ...f, password: e.target.value }))}
                  placeholder="min. 6 znaków" />
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-cancel" disabled={approvingApp} onClick={() => setApproveAppModal(null)}>Anuluj</button>
                <button type="submit" className="btn-confirm" disabled={approvingApp}>
                  {approvingApp ? 'Tworzenie...' : 'Utwórz konto i zaakceptuj'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;